module.exports = __webpack_public_path__ + "img/Map_1__Realignment.0b39a896.jpg";